import { createContext, useState } from "react";
import "./App.css";
import About from "./components/About/About";
import Contract from "./components/Contract/Contract";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import NavBar from "./components/NavBar/NavBar";
import ParticlesBackground from "./components/ParticlesBackground/ParticlesBackground";
import Projects from "./components/Projects/Projects";
import Services from "./components/Services/Services";
import Skills from "./components/Skills/Skills";
export const UserContext = createContext();

function App() {
  const [navbar, setNavbar] = useState(false);
  const onBackgroundChange = () => {
    console.log(navbar);
    if (window.scrollY >= 70) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  window.addEventListener("scroll", onBackgroundChange);
  return (
    <UserContext.Provider value={[navbar, setNavbar]}>
      <div>
        <NavBar></NavBar>
        <div className="header_area">
          <div className="particles">
            <ParticlesBackground></ParticlesBackground>
          </div>
          <Home></Home>
        </div>
        <About />
        <Services />
        <Skills />
        <Projects />
        <Contract />
        <Footer />
      </div>
    </UserContext.Provider>
  );
}

export default App;
